import { claimAlert as claim } from './alertLedger.mjs';
import { eligibleAlert, messageAlert } from './openSessionPolicy.mjs';

let session = null;
let suspendedSession = null;

export function startAlertSession(userId, accountId) {
  if (session?.active && String(session.userId) === String(userId) && String(session.accountId) === String(accountId)) return;
  session = userId && accountId ? { active: true, userId, accountId, startedAt: Date.now() } : null;
}
export function stopAlertSession() { session = null; suspendedSession = null; }

export async function claimNewAudio(message) {
  const active = session;
  const event = messageAlert(message, active);
  if (!eligibleAlert(active, event)) return false;
  const accepted = await claim(`audio:${active.userId}:${active.accountId}:${event.key}`);
  return session === active && accepted;
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', event => {
    suspendedSession = event.persisted ? session : null;
    session = null;
  });
  window.addEventListener('pageshow', event => {
    const previous = suspendedSession;
    suspendedSession = null;
    if (event.persisted && previous) startAlertSession(previous.userId, previous.accountId);
  });
}

export async function showDesktopAlert(notification) {
  const active = session;
  const event = notification?.devlive_event;
  if (!event || !eligibleAlert(active, event) || globalThis.Notification?.permission !== 'granted') return;
  let url;
  try { url = new URL(notification.url); } catch { return; }
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/app/')) return;
  const key = `desktop:${active.userId}:${active.accountId}:${event.key}`;
  try {
    const registration = await navigator.serviceWorker?.getRegistration('/');
    if (!registration || session !== active || !await claim(key) || session !== active) return;
    await registration.showNotification(notification.title, { tag: key, renotify: false, data: { url: url.href } });
  } catch { /* Keep history intact; unsupported desktop notifications do not break the app. */ }
}
